// Messages/EmptyState.jsx
// Component for displaying empty messages state

import React from 'react';
import { styles } from './styles';

// Empty Inbox Icon SVG
const EmptyInboxIcon = () => (
  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </svg>
);

const EmptyState = () => {
  return (
    <div style={styles.emptyStateContainer}>
      <div style={styles.emptyIcon}>
        <EmptyInboxIcon />
      </div>
      <h3 style={styles.emptyTitle}>No Conversations Yet</h3>
      <p style={styles.emptyMessage}>
        Start messaging by contacting sellers on listing pages!
      </p>
    </div>
  );
};

export default EmptyState;